import React from "react"

export const SuccessModalContext = React.createContext()
